import styled from 'styled-components';
import { color, screen, spacing } from 'theme';

export const Root = styled.div`
  background: ${color('sun_100')};
  padding: ${spacing('xl6')} 0;

  @media (max-width: ${screen('lg')}) {
    padding: ${spacing('xl2')} 0;
  }
`;

export const Intro = styled.div`
  text-align: center;
  max-width: 55rem;
  margin: auto;

  h3 {
    margin-bottom: 0;
  }

  p {
    font-size: 1.25rem;
    margin-bottom: 2rem;
  }
`;

export const Features = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: 1.25rem;

  @media (max-width: ${screen('lg')}) {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
  }
`;

export const Feature = styled.div`
  background: #fff;
  box-shadow: 0px 7.57px 11.35px 0px #261a191a;
  box-shadow: 0px 3.03px 4.54px 0px #261a190d;
  padding: 2.5rem;
  border-radius: 10px;

  h4 {
    color: ${color('indigo_700')};
    margin-bottom: 0.5rem;
    border-bottom: 4px solid ${color('indigo_300')};
    display: inline-flex;
  }

  h5 {
    margin-bottom: 0;
  }

  p {
  }
`;
